import React from "react";

/**
 * Cluster movements from a refresh summary, biggest absolute volume change
 * first — mirroring notableChanges() in the refresh service so the screen and
 * the summary email rank the same rows.
 */
const KeywordDiffTable = ({ diff, limit = 10 }) => {
  const rows = [...(diff || [])]
    .filter(d => d.volumeDelta !== 0 || d.positionBefore !== d.positionAfter)
    .sort((a, b) => Math.abs(b.volumeDelta) - Math.abs(a.volumeDelta))
    .slice(0, limit);

  if (!rows.length) {
    return (
      <p className="text-sm text-gray-500 px-5 py-4">
        No measurable movement — volumes and rankings are unchanged.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-gray-500 border-b border-gray-200">
            <th className="px-5 py-2 font-medium">Cluster</th>
            <th className="px-5 py-2 font-medium text-right">Volume</th>
            <th className="px-5 py-2 font-medium text-right">Δ</th>
            <th className="px-5 py-2 font-medium text-right">Best position</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rows.map(d => {
            const up   = d.volumeDelta > 0;
            const down = d.volumeDelta < 0;
            return (
              <tr key={d.id} className="hover:bg-gray-50">
                <td className="px-5 py-2 font-medium text-gray-900">{d.id}</td>
                <td className="px-5 py-2 text-right text-gray-600 tabular-nums">
                  {d.volumeBefore} → {d.volumeAfter}
                </td>
                <td className={`px-5 py-2 text-right tabular-nums font-medium ${
                  up ? "text-green-600" : down ? "text-red-600" : "text-gray-400"
                }`}>
                  {up ? "+" : ""}{d.volumeDelta}
                </td>
                <td className="px-5 py-2 text-right text-gray-600 tabular-nums">
                  {d.positionBefore ?? "—"} → {d.positionAfter ?? "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default KeywordDiffTable;
